import { Routes } from '@angular/router';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AuthGuard, LaunchDarklyUserGuard, RoleBasedGuard } from 'remarketing-angular-library';
import { AuctionSummaryArbitrationResolver } from '../shared/arbitration';
import { UnsavedFormGuard } from '../profile-management/guards/unsaved-form.guard';
import { auctionSummaryReactGuard } from './guards/auction-summary-react-version.guard';

export const auctionSummaryRoutes: Routes = [
  {
    // First match wins. Flag off -> auctionSummaryReactGuard's canMatch returns false, this
    // entry does not match, and the Angular AuctionSummaryShellComponent entry below serves the
    // same path — rollback needs no deploy. Mirrors src/dashboard/dashboard.routes.ts.
    path: 'purchase/auction-summary',
    loadComponent: () =>
      import('./react-host/react-auction-summary-host.component').then(
        c => c.ReactAuctionSummaryHostComponent,
      ),
    canMatch: [auctionSummaryReactGuard],
    canActivate: [
      AgreementsGuard,
      LaunchDarklyUserGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data : {
      flag: 'auctionSummaryEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    },
  },
  {
    path: 'purchase/auction-summary',
    loadComponent: () => import('./components/auction-summary-shell/auction-summary-shell.component').then(c => c.AuctionSummaryShellComponent),
    canActivate: [
      AgreementsGuard,
      LaunchDarklyUserGuard,
      AuthGuard,
      RoleBasedGuard
    ],
    data : {
      flag: 'auctionSummaryEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    },
  },
  {
    path: 'purchase/auction-summary/report-previews',
    loadComponent: () => import('./components/auction-summary-report-preview-shell/auction-summary-report-preview-shell.component').then(c => c.AuctionSummaryReportPreviewShellComponent),
    canActivate: [AgreementsGuard, AuthGuard, RoleBasedGuard],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    }
  },
  {
    path: 'purchase/auction-summary/arbitration',
    canActivate: [AuthGuard, RoleBasedGuard],
    children: [
      {
        path: 'new',
        //@TODO change url in auction-summary-static-footer.component.ts & test when this is changed to '/auction-summary'
        redirectTo: '/auction-summary',
        pathMatch: 'full'
      },
      {
        path: ':auctionItemUuid/new',
        loadComponent: () => import('../shared/arbitration').then(c => c.AuctionSummaryArbitrationManageComponent),
        canActivate: [AgreementsGuard],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ]
        }
      },
      {
        path: ':auctionItemUuid/:claimNumber',
        resolve: {
          arbitration: AuctionSummaryArbitrationResolver,
        },
        loadComponent: () => import('../shared/arbitration').then(c => c.AuctionSummaryArbitrationManageComponent),
        canActivate: [AgreementsGuard],
        canDeactivate: [UnsavedFormGuard],
        data: {
          guards: [
            GUARDS.TermsOfUseGuard,
            GUARDS.PrivacyPolicyGuard
          ],
          roles: ['View_Only']
        }
      },
    ],
    data: {
      roles: ['View_Only']
    }
  }
];
